<template>
  <svg
    v-svg
    :symbol="symbol"
    class="unraid-svg-icon"
    :class="symbolClass"
    role="presentation"
  ></svg>
</template>

<script>
import Vue from 'vue';
import SvgSprite from 'vue-svg-sprite';

Vue.use(SvgSprite, {
  url: `${
    process.env.VUE_APP_SPRITE_URL_PREFIX
      ? process.env.VUE_APP_SPRITE_URL_PREFIX
      : ''
  }/assets/svg/sprite.svg`,
  class: 'svg-icon'
});

/**
 * @name Unraid SVG Icon
 * @description SVG Icon system
 * @vue-prop {string} symbol - required, represents the ID associated with the SVG you want to use from the global SVG Sprite generated by `svg-sprite`
 * @example <svg-icon symbol="case--full-tower" />
 */
export default {
  name: 'svg-icon',
  props: {
    symbol: {
      type: String,
      required: true
    },
    symbolClass: String
  }
};
</script>

<style scoped>
.unraid-svg-icon {
  color: inherit;
  display: inline-block;
  vertical-align: middle;
  fill: currentColor;
  stroke: none;
}
</style>
